"use strict";
// eslint-disable-next-line spaced-comment
/// <reference types="chrome"/>
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeMessageTransport = void 0;
const Logger_1 = require("../utils/Logger");
const __1 = require("..");
const logger = new Logger_1.Logger('ChromeMessageTransport');
class ChromeMessageTransport extends __1.Transport {
    constructor(name) {
        super(name);
        this.type = __1.TransportType.CHROME_MESSAGE;
        this.init().catch((error) => console.error(error));
    }
    static async isAvailable() {
        const isAvailable = !!(window.chrome && chrome.runtime && chrome.runtime.id);
        return Promise.resolve(isAvailable);
    }
    async send(payload) {
        const message = {
            target: __1.ExtensionMessageTarget.PAGE,
            payload
        };
        chrome.runtime.sendMessage(message, (data) => {
            logger.log('send', 'got response', data);
        });
    }
    async init() {
        chrome.runtime.onMessage.addListener((message, sender, sendResponse) => {
            logger.log('init', 'receiving chrome message', message, sender);
            const connectionContext = {
                origin: __1.Origin.WEBSITE,
                id: sender.url ? sender.url : '',
                extras: { sender, sendResponse }
            };
            this.notifyListeners(message, connectionContext).catch((error) => logger.error(error));
            // return true from the event listener to indicate you wish to send a response asynchronously
            // (this will keep the message channel open to the other end until sendResponse is called).
            return true;
        });
    }
}
exports.ChromeMessageTransport = ChromeMessageTransport;
//# sourceMappingURL=ChromeMessageTransport.js.map